<template>
	<view class="box">
		<view class="list">
			<view class="list-item">
				<view class="list-item-label">收件人</view>
				<view class="list-item-input">
					<input type="text" placeholder="请输入收件人姓名" />
				</view>
			</view>
			<view class="list-item">
				<view class="list-item-label">联系电话</view>
				<view class="list-item-input">
					<input type="text" placeholder="请输入联系电话" />
				</view>
			</view>
			<view class="list-item">
				<view class="list-item-label">所在地区</view>
				<view class="list-item-sele">
					<text>请选择</text>
					<u-icon name="arrow-right" color="#B2B2B2" size="16"></u-icon>
				</view>
			</view>
			<view class="list-item">
				<view class="list-item-label">详细地址</view>
				<view class="list-item-input">
					<textarea placeholder="请输入详情地址"></textarea>
				</view>
			</view>
			<view class="list-item" style="display: flex; align-items: center; justify-content: space-between;">
				<view class="list-item-label">设为默认地址</view>
				<u-switch v-model="value"></u-switch>
			</view>
			<view class="box-footer">
				<view class="btn1">删除</view>
				<view class="btn2">保存</view>
			</view>
		</view>
	</view>
</template>

<script>
	export default {
		data() {
			return {
				value: 0
			};
		}
	}
</script>

<style>
	page {
		background-color: #F9F9FB;
	}
</style>
<style lang="scss" scoped>
	.box {
		width: 100%;
		padding: 30rpx;
		box-sizing: border-box;
		.list {
			width: 100%;
			padding: 38rpx 30rpx;
			box-sizing: border-box;
			background: #FFFFFF;
			box-shadow: 0rpx 0rpx 12rpx 0rpx rgba(0,0,0,0.08);
			border-radius: 16rpx;
			.box-footer {
				width: 100%;
				display: flex;
				align-items: center;
				margin-top: 100rpx;
				.btn1 {
					flex: 1;
					height: 88rpx;
					line-height: 88rpx;
					text-align: center;
					border-radius: 44rpx;
					font-weight: 500;
					font-size: 32rpx;
					color: #004096;
					border: 1rpx solid #004096;
					margin-right: 22rpx;
				}
				.btn2 {
					flex: 1;
					height: 88rpx;
					line-height: 88rpx;
					text-align: center;
					background: #004096;
					border-radius: 44rpx;
					font-weight: 500;
					font-size: 32rpx;
					color: #FFFFFF;
				}
			}
			.list-item {
				width: 100%;
				padding-bottom: 24rpx;
				box-sizing: border-box;
				margin-bottom: 28rpx;
				border-bottom: 1rpx solid #E5E5E5;
				&:last-child {
					margin: 0 !important;
				}
				.list-item-label {
					font-weight: 500;
					font-size: 28rpx;
					color: #111111;
				}
				.list-item-sele {
					width: 100%;
					margin-top: 15rpx;
					display: flex;
					align-items: center;
					justify-content: space-between;
					text {
						font-weight: 400;
						font-size: 30rpx;
						color: #999999;
					}
				}
				.list-item-input {
					width: 100%;
					margin-top: 15rpx;
					input {
						font-weight: 400;
						font-size: 30rpx;
						color: #111111;
					}
					textarea {
						width: 100%;
						height: 130rpx;
					}
				}
			}
		}
	}
</style>